module.exports = __webpack_public_path__ + "img/img_xuzhi.0c09eb67.jpg";